export default __webpack_public_path__ + "static/media/event_modal.e3a9b01d.jpg";